// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TermsAndConditions_wrapper__tyzAx"};